import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

interface IUserMarkedUnknownByMeData {
  userId: string;
  isUnknown: boolean;
}

export class UserMarkedUnknownByMe extends GroupsEvent<IUserMarkedUnknownByMeData> {
  process(): void {
    if (!this.eventPayload) {
      return;
    }

    const user = Entities.usersStore.getUserById(this.eventPayload.userId);

    if (user) {
      user.setIsUnknown(this.eventPayload.isUnknown);
    }
  }
}
